import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type ActionsEnum, actionsEnum } from "kubb";
import type React from "react";
import UncontrolledTooltip from "../Theme/tooltip";

interface Props {
  index: string;
  status: ActionsEnum;
  executed: boolean;
  executedSuccess: boolean;
  immutableChangeErrors: string[];
  validationErrors?: string[];
  executionErrors: string[];
  changedProperties: string[];
}

const GenericUpdateTooltip = (props: Props): React.ReactElement => {
  const {
    index,
    status,
    executed,
    executedSuccess,
    immutableChangeErrors,
    validationErrors = [],
    executionErrors,
    changedProperties,
  } = { ...props };

  const hasErrors =
    immutableChangeErrors.length +
      validationErrors.length +
      executionErrors.length >
    0;

  const tooltipContent = (): string => {
    if (executed) {
      if (executedSuccess || executionErrors.length > 0) {
        const success = executedSuccess && !hasErrors;
        const actionsEnumtatus = success
          ? "completed"
          : `failed ${describeErrors()}`;
        return `${status}: ${actionsEnumtatus}`;
      } else {
        return `${status}: in progress`;
      }
    } else {
      return `${status} ${
        status === actionsEnum.UPDATE
          ? hasErrors
            ? describeErrors()
            : changedProperties
          : ""
      }`;
    }
  };
  const describeErrors = (): string => {
    if (executed && executionErrors.length > 0) {
      return executionErrors.join(", ");
    } else {
      return hasErrors ? validationErrors.join(", ") : "";
    }
  };

  const text = tooltipContent();
  const icon = (): IconProp => {
    if (hasErrors) {
      return faExclamationTriangle;
    } else {
      if (status === actionsEnum.NEW) {
        return faPlusCircle;
      }
      if (status === actionsEnum.UPDATE) {
        return faCheckCircle;
      }
    }
    if (status === actionsEnum.DELETED) {
      return faMinusCircle;
    }
    if (status === actionsEnum.NOT_FOUND) {
      return faExclamationCircle;
    }
    return faCircle;
  };
  return (
    <UncontrolledTooltip key={index} message={text} placement={"right"}>
      <FontAwesomeIcon fixedWidth={true} icon={icon()} />
    </UncontrolledTooltip>
  );
};

export default GenericUpdateTooltip;
